<ion-header class="ion-no-border">
  <ion-toolbar>  
    <ion-buttons slot="start">
      <ion-button icon-only (click)="dismiss()">
        <ion-icon name='close'></ion-icon>
      </ion-button>
    </ion-buttons>

    <smr-stylist-picker 
      [readOnly]="readOnlyStylistPicker"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelectChange($event)"
      [showAllStaff]="true"
      cssClass = "smr-stylist-picker-for-clients"
      >
    </smr-stylist-picker>
  </ion-toolbar>
</ion-header>

<ion-content>

  <salonmonster-load-mask *ngIf="isLoadingStylists"></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingStylists" (click)="onRetry()"></salonmonster-tap-retry>

  <smr-client-picker 
    *ngIf="stylist" 
    [stylist]="stylist" 
    (clientSelect)="onClientSelect($event)"
    >
  </smr-client-picker>

<!--   <div>
    <ion-item [hidden]="!isLoading">
      <ion-spinner icon='crescent'></ion-spinner>
      &nbsp;Searching for "{{searchTerm}}" ...
    </ion-item>

    <ion-item [hidden]="!errorOccurred" class='sm-error'>
     Oops, an error occurred. Please try again.
    </ion-item>

    <ion-item [hidden]="isLoading || !searchTerm || searchTerm == '' || clientList.count() > 0">
      No results found.
    </ion-item>

    <sm-client-list
      *ngIf="!isLoading && (searchTerm || searchTerm != '') && clientList.count() > 0"
      [clients]="clientList"
      (clientSelect)="onClientSelect($event, true)"
    >
    </sm-client-list>
    <sm-client-search-history
      *ngIf="!isLoading && (!searchTerm || searchTerm == '') && clientList.count() == 0 && clientSearchHistory.count() > 0"
      [clients]="clientSearchHistory"
      (clientSelect)="onClientSelect($event, false)"
    >
    </sm-client-search-history>
  </div> -->
</ion-content>